import React from 'react';
import { connect } from 'react-redux';
import { isSectionLoading } from '../selectors/sections';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';

const mapStateToProps = state => ({
  isSectionLoading: isSectionLoading(state),
});

const withSectionFetchSpinner = ChildComponent =>
  connect(mapStateToProps, {})(
    props =>
      props.isSectionLoading ? (
        <LoadingIndicator />
      ) : (
        <ChildComponent {...props} />
      )
  );

export default withSectionFetchSpinner;
